import { get, post } from '../request';

export async function fetchPreference(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/usermaintenance`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function persistPreference(
  { userService },
  authenticationToken,
  { userId, data },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/usermaintenance`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchAppealsType(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsStatus(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsReason(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Reasons`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchRevisionHistoryByUser(
  { appraisalService },
  authenticationToken,
  { payload, page, pageSize },
) {
  const url = `${appraisalService}/appraisal/revisionhistory/user?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
